import {Variable} from '@packages/systems/wfdl';
import {identifier} from '@packages/systems/wfdl-Qualified';

/**
 * Some plugins are imported into the renderer (they shouldn't be and we'll work on that)
 *
 * To avoid circular dependencies we've hoisted a few of those constants here.
 */
export const FIGCAPTION_PLACEHOLDER_TEXT = 'Type image caption here (optional)';

export const localesListItemVariable = Variable.unqualified(
  identifier('localesListItem')
);

export const localesListActiveItemVariable = Variable.unqualified(
  identifier('localesListActiveItem')
);

export type LocaleItemContext = {
  _id: string;
  cmsId?: string | null;
  tag: string; // the iso code of the locale;
  languageCode: string; // the language code extracted from the tag (e.g., 'en' from 'en-US')
  countryCode: string; // the country code extracted from the tag (e.g., 'US' from 'en-US'). Defaults to empty string
  displayName: string; // the human readable name of the locale, customizable by the user;
  displayImageId?: string | null; // an optional image to display things like flags
  subdirectory: string; // the first segment of the url path for the locale;
  active: boolean; // a boolean value set to true only if the locale is the current one;
  primary: boolean; // a boolean value set to true only if the locale is the primary one;
  pageId?: string | null;
  pageHref?: string | null;
  noPageAvailable?: boolean;
  canonicalUrl?: string | null; // canonical url override for the locale
  draft?: boolean;
};

export const pageVariable = Variable.unqualified(identifier('page'));

export type PageContext = {
  name: [string];
  parentFolderName: [string];
  seoTitle: [string];
  seoDesc: [string];
  ogTitle: [string];
  ogDesc: [string];
  ogImage: {id: string} | {url: string};
};
